module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "row alert status-box alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "col media",
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_vm._v("\n                " + _vm._s(_vm.error) + "\n                "), _c('i', {
    staticClass: "fa fa-remove",
    staticStyle: {
      "float": "right",
      "margin-top": "3px"
    },
    on: {
      "click": function($event) {
        _vm.error = false
      }
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.first),
      expression: "form.first"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.first)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.first = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.last),
      expression: "form.last"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.last)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.last = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Company Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.company_name),
      expression: "form.company_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.company_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.company_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Company Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('google-address-searcher', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.address),
      expression: "form.address"
    }],
    attrs: {
      "selected": _vm.form.address.formatted_address
    },
    domProps: {
      "value": (_vm.form.address)
    },
    on: {
      "input": function($event) {
        _vm.form.address = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-7  col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Tier 1 Comms")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier1_commsrate),
      expression: "form.tier1_commsrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier1_commsrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier1_commsrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label"
  }, [_vm._v("Tier 1 Spiff")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier1_spiffrate),
      expression: "form.tier1_spiffrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier1_spiffrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier1_spiffrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Tier 2 Comms")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier2_commsrate),
      expression: "form.tier2_commsrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier2_commsrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier2_commsrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label"
  }, [_vm._v("Tier 2 Spiff")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier2_spiffrate),
      expression: "form.tier2_spiffrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier2_spiffrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier2_spiffrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Tier 3 Comms")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier3_commsrate),
      expression: "form.tier3_commsrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier3_commsrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier3_commsrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2 offset-lg-2 col-form-label"
  }, [_vm._v("Tier 3 Spiff")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier3_spiffrate),
      expression: "form.tier3_spiffrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier3_spiffrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier3_spiffrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Tier 4 Comms")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier4_commsrate),
      expression: "form.tier4_commsrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier4_commsrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier4_commsrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-5 col-sm-7 col-md-3 col-lg-2 col-lg-2  offset-lg-2 col-form-label"
  }, [_vm._v("Tier 4 Spiff")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.tier4_spiffrate),
      expression: "form.tier4_spiffrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.tier4_spiffrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.tier4_spiffrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-7  col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Agent")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-5 col-lg-4"
  }, [_c('auto-complete', {
    attrs: {
      "placeholder": "Choose Agent",
      "list": _vm.agentNames,
      "selection": _vm.exception_name
    },
    on: {
      "change": _vm.setExceptionAgent,
      "input": _vm.fetchAgents
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-7  col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Comms ")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.exception_commsrate),
      expression: "form.exception_commsrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.exception_commsrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.exception_commsrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-5 col-sm-7  col-md-3 col-lg-2 col-form-label"
  }, [_vm._v("Spiff")]), _vm._v(" "), _c('div', {
    staticClass: "col-7 col-sm-5 col-md-3 col-lg-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.exception_spiffrate),
      expression: "form.exception_spiffrate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.form.exception_spiffrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.exception_spiffrate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                        %\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-clear",
    on: {
      "click": function($event) {
        _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveAgent
    }
  }, [_vm._v("Save New Agent")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex mr-2 status-icon",
    staticStyle: {
      "margin-top": "3px"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Commissions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Exception")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-008a5479!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agents/AddAgent.vue
// module id = 350
// module chunks = 0